module.exports = __webpack_public_path__ + "static/media/GACertified.1b0807db.pdf";